'use strict';

var formDynamicPages = function () {
  var formSelector = '.js-form-dynamic-pages';
  var $form = $(formSelector);
  var _getModels = function _getModels() {
    $.getJSON('https://red.nissan.es/getJsonModelosDivision').done(function (data) {
      return _buildModelsSelect(data);
    });
  };

  var _buildModelsSelect = function _buildModelsSelect(json) {
    var sortedModels = json.sort(function (a, b) {
      return a.orden - b.orden;
    });
    for (var i = 0; i < sortedModels.length; i++) {
      $form.find('.js-select-model').append('<option value="' + sortedModels[i].nom_es + '">' + sortedModels[i].nom_es + '</option>');
    }
  };

  var _initDatepicker = function _initDatepicker() {
    $form.find('[data-toggle="datepicker"]').datepicker({
      language: 'es-ES',
      format: 'dd/mm/yyyy'
    });
  };

  var _initValidation = function _initValidation() {
    var formValidate = new PlanSimpleValidator(formSelector, {
      rules: {
        concesion: {
          required: true,
          messages: {
            required: 'Campo obligatorio'
          }
        },
        surname1: {
          required: true,
          alphabetical: true,
          messages: {
            required: 'Campo obligatorio',
            alphabetical: 'Sólo caracteres alfabéticos'
          }
        },
        cp: {
          required: true,
          cpES_AD: true,
          messages: {
            required: 'Campo obligatorio',
            cpES_AD: 'Código postal no válido'
          }
        }
      },
      submitHandler: function submitHandler(form) {
        var obj = {
          form: form,
          submit$Selector: '.js-label-submit',
          submitText: 'ENVIANDO...',
          toHide: '.js-to-hide',
          toShow: '.js-to-show',
          close$Selector: '.js-close',
          useReCaptcha: true,
          okURL: globalEnv + 'es/public/dist/_thankyou-ok.html',
          koURL: globalEnv + 'es/public/dist/_thankyou-ko.html'
        };
        window.googleDataLayer = window.googleDataLayer || [];
        window.googleDataLayer.push({
          'event': 'pide tu cita'
        });
        formCommons.sendAjax(obj);
      }
    });
  };

  var _init = function _init() {
    _getModels();
    _initDatepicker();
    _initValidation();
  };
  return {
    init: _init
  };
}();